<section class="form">
  <header class="form__section form__section_header">
    <app-header title="{{'Customer Information' | translate}}"></app-header>
  </header>
  <form class="form__section form__section_content"
    [formGroup]="formGroup"
  >
    <div class="section">
      <!-- NAME -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputName.id"
              >{{'Name' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item">
                <app-input #inputName
                  type="text"
                  name="lastName"
                  placeholder="{{'Family name' | translate}}"
                  formControlName="lastName"
                ></app-input>
              </div>
              <div class="input__item">
                <app-input #inputName2
                  type="text"
                  name="firstName"
                  placeholder="{{'Given name' | translate}}"
                  formControlName="firstName"
                ></app-input>
              </div>
            </div>
            <app-error class="error"
              [error]="NAME_ERROR"
              [@slideY]
              *ngIf="(
                inputName.showError
                || inputName2.showError
              )"
            ></app-error>
          </div>
        </div>
      </div>
      <!-- Postal Code -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputPostalCode.id"
              >{{'Postal Code' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item input__item_sm">
                <app-input #inputPostalCode
                  type="text"
                  name="postalCodeFirst"
                  placeholder="123"
                  formControlName="postalCodeFirst"
                ></app-input>
              </div>
              <div class="input__span"></div>
              <div class="input__item input__item_sm">
                <app-input #inputPostalCode2
                  type="text"
                  name="postalCodeSecond"
                  placeholder="4567"
                  formControlName="postalCodeSecond"
                ></app-input>
              </div>
            </div>
            <app-error class="error"
              [error]="POSTAL_CODE_ERROR"
              [@slideY]
              *ngIf="(
                inputPostalCode.showError
                || inputPostalCode2.showError
              )"
            ></app-error>
          </div>
        </div>
      </div>
      <!-- Address 1 -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputAddressFirst.id"
              >{{'Address 1' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item">
                <app-input #inputAddressFirst
                  type="select"
                  name="addressFirst"
                  formControlName="addressFirst"
                  [error]="ADDRESS_1_ERROR"
                >
                  <option *ngFor="let region of regions; index as i"
                    [value]="i"
                  >{{ region.name }}</option>
                </app-input>
              </div>
              <!-- adding to fill empty space making input 50% size -->
              <div class="input__item"
                fxHide.lt-sm
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Address 2 -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputAddressSecond.id"
              >{{'Address 2' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item">
                <app-input #inputAddressSecond
                  type="text"
                  name="addressSecond"
                  placeholder="{{'Shibuya Sendagaya' | translate}}"
                  formControlName="addressSecond"
                  [error]="ADDRESS_2_ERROR"
                ></app-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Address 3 -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputAddressThird.id"
              >{{'Address 3' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item">
                <app-input #inputAddressThird
                  type="text"
                  name="addressThird"
                  placeholder="{{'3-15-3 Maffice Kitasando' | translate}}"
                  formControlName="addressThird"
                  [error]="ADDRESS_3_ERROR"
                ></app-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Phone -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputPhone.id"
              >{{'Phone' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input">
              <div class="input__item input__item_sm">
                <app-input #inputPhone
                  type="text"
                  name="phoneFirst"
                  placeholder="123"
                  formControlName="phoneFirst"
                ></app-input>
              </div>
              <div class="input__span"></div>
              <div class="input__item input__item_sm">
                <app-input #inputPhone2
                  type="text"
                  name="phoneSecond"
                  placeholder="4567"
                  formControlName="phoneSecond"
                ></app-input>
              </div>
              <div class="input__span"></div>
              <div class="input__item input__item_sm">
                <app-input #inputPhone3
                  type="text"
                  name="phoneThird"
                  placeholder="8901"
                  formControlName="phoneThird"
                ></app-input>
              </div>
            </div>
            <app-error class="error"
              [error]="PHONE_ERROR"
              [@slideY]
              *ngIf="(
                inputPhone.showError
                || inputPhone2.showError
                || inputPhone3.showError
              )"
            ></app-error>
          </div>
        </div>
      </div>
      <!-- Email Address -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputEmail.id"
              >{{'Email Address' | translate}}</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input"
              [ngClass]="{
                'input_column': media.isActive('lt-sm')
              }"
            >
              <div class="input__item">
                <app-input #inputEmail
                  type="email"
                  name="email"
                  placeholder="sample@hellobuki.com"
                  formControlName="email"
                  [error]="EMAIL_ERROR"
                ></app-input>
              </div>
              <div class="input__item"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Email Address 2 -->
      <div class="section__input">
        <div class="input-wrap"
          [ngClass]="{
            'input-wrap_column': media.isActive('lt-sm')
          }"
        >
          <div class="input-wrap__label">
            <div class="label">
              <app-label class="label__item"
                [forId]="inputEmail2.id"
              >同じメールアドレスを入力してください</app-label>
            </div>
          </div>
          <div class="input-wrap__input">
            <div class="input"
              [ngClass]="{
                'input_column': media.isActive('lt-sm')
              }"
            >
              <div class="input__item">
                <app-input #inputEmail2
                  type="email2"
                  name="email2"
                  placeholder="sample@hellobuki.com"
                  formControlName="email2"
                  [error]="EMAIL_MATCH_ERROR"
                ></app-input>
              </div>
              <div class="input__item input__item_checkbox">
                <app-input
                  type="checkbox"
                  label="{{'Receive newsletters from BÜKI'| translate}}"
                  name="emailReceive"
                  placeholder="sample@hellobuki.com"
                  formControlName="emailReceive"
                ></app-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
